import React from 'react';
import { Menu, Layout, Icon, Card, Button } from 'antd';
import { browserHistory } from 'react-router';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

export default class HelpDoc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            //navMenus:  [],
            uid: props.location.query.uid,
            loaded: false,
        }
        //this.getMenuByServer();
    }
    componentWillMount() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "./HelpDoc.js";
        let me = this;
        //IE    
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == 'loaded' || script.readyState == 'complete') {
                    script.onreadystatechange = null;
                    me.setState({
                        loaded: true
                    })
                }
            };

        } else {
            //其他浏览器    
            script.onload = function () {
                me.setState({
                    loaded: true
                })
            };

        }
        document.getElementsByTagName('head')[0].appendChild(script);

    }
    componentDidMount() {
        let me = this;
        if (me.state.uid) {
            setTimeout(() => {
                me.jump(me.state.uid);
            }, 300)
        }

    }
    // 获取菜单
    // getMenuByServer() {
    //     var me = this;

    //     var req = {
    //         "userId": tool.getCookie('id'),
    //         "channelId": "0"
    //     };
    //     tool.sgiLogger.info(req, 'getMenuByServer')
    //     var success = function (res) {
    //         tool.sgiLogger.info(res, 'getMenuByServer')
    //         if (res && res.head.code == "0000") {
    //             me.setState({
    //                 navMenus: res.body
    //             })
    //         }
    //     };
    //     commonClient.simplecall(sgiConfig.allUrl.userGetUserMenus, req, success, true)
    // }
    // createMenus(arr) {
    //     if (!arr) { return }
    //     let that = this;
    //     return arr.map((item, index) => {
    //         switch (item.type) {
    //             case "2":
    //                 return <Menu.Item onClick={this.menusClick.bind(this, item)} key={item.menuId} ><Icon type={item.img || "arrow-right"} /><span>{item.name}</span></Menu.Item>
    //                 break;
    //             default:
    //                 return <SubMenu key={item.menuId} title={<span><Icon type={item.img || "appstore"} /><span>{item.name}</span></span>}>{that.createMenus(item.children)}</SubMenu>
    //         }
    //     })
    // }
    createMenus(arr) {
        if (!arr) { return }
        return arr.map((item, index) => {
            return <Menu.Item onClick={this.menusClick.bind(this, item)} key={item.uid} ><Icon type={"arrow-right"} /><span>{item.name}</span></Menu.Item>
        })
    }
    createCard(arr) {
        if (!arr) { return }
        return arr.map((item, index) => {
            let xmlDoc = <p>{item.name + "帮助手册正在完善中..."}</p>
            if (sgiSrvUrl.HelpDoc[item.uid]) {
                var html = { __html: sgiSrvUrl.HelpDoc[item.uid] };
                xmlDoc = <div dangerouslySetInnerHTML={html}></div>
            }
            return <Card title={item.name} extra={<a style={{ position: "relative", top: "-30" }} name={item.uid}></a>} style={{ width: "100%", marginBottom: "5px" }}>
                {xmlDoc}
            </Card>
        })
    }
    // createCard(arr) {
    //     if (!arr) { return }
    //     let that = this;

    //     return arr.map((item, index) => {
    //         switch (item.type) {
    //             case "2":
    //                 let xmlDoc = <p>{item.funcName + "帮助手册正在完善中..."}</p>
    //                 if (sgiSrvUrl.HelpDoc[item.uid]) {
    //                     var html = { __html: sgiSrvUrl.HelpDoc[item.uid] };
    //                     xmlDoc = <div dangerouslySetInnerHTML={html}></div>
    //                 }

    //                 return <Card title={item.funcName} extra={<a style={{ position: "relative", top: "-30" }} name={item.uid}></a>} style={{ width: "100%", marginBottom: "5px" }}>
    //                     {xmlDoc}
    //                 </Card>
    //                 break;
    //             default:
    //                 return that.createCard(item.children);
    //         }
    //     })
    // }
    // 点击菜单
    menusClick(e) {
        this.jump(e.uid);
    }
    jump(id) {
        let a = document.createElement("a");
        a.setAttribute("href", "#" + id);
        a.click();
    }
    btnClick() {
        browserHistory.push({
            pathname: "/",
            query: {},
        });
    }
    render() {
        let navMenus = sgiSrvUrl.HelpDocMenu || [];
        let re = [];
        if (sgiSrvUrl.HelpDoc) {
            re = this.createCard(navMenus);
            let xmlDoc = <p>{"工作台帮助手册正在完善中..."}</p>
            if (sgiSrvUrl.HelpDoc["workbench"]) {
                var html = { __html: sgiSrvUrl.HelpDoc["workbench"] };
                xmlDoc = <div dangerouslySetInnerHTML={html}></div>
            }
            re.unshift(<Card title={"工作台"} extra={<a style={{ position: "relative", top: "-30" }} name={"workbench"}></a>} style={{ width: "100%", marginBottom: "5px" }}>{xmlDoc}</Card>)
        }

        return <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
            {/* <Button onClick={this.btnClick.bind(this)} type="primary" icon="arrow-left" size={"large"} style={{ zIndex: "99999", position: "fixed", top: "0", right: "0" }}></Button> */}
            <Layout style={{ height: "100%" }}>
                <Sider style={{ width: "auto" }}>
                    <Menu
                        defaultOpenKeys={[this.state.uid]}
                        defaultSelectedKeys={[this.state.uid]}
                        style={{ height: "100%", width: "100%", overflowY: "auto", overflowX: "hidden" }}
                        mode="inline"
                    >
                        {this.createMenus(navMenus)}
                    </Menu>
                </Sider>
                <Content style={{ boxSizing: "border-box", padding: "5px" }}>
                    {re}
                </Content>
            </Layout>
        </div>
    }
}


// WEBPACK FOOTER //
// ./apps/pages/main/HelpDoc.js